<template>
  <icon-svg-base :class="$style.path" :view-width="40" :view-height="40">
    <path
      d="m23.3 20l-13.1-13.6c-0.3-0.3-0.3-0.9 0-1.2l2.4-2.4c0.3-0.3 0.9-0.4 1.2-0.1l16 16.7c0.1 0.1 0.2 0.4 0.2 0.6s-0.1 0.5-0.2 0.6l-16 16.7c-0.3 0.3-0.9 0.3-1.2 0l-2.4-2.5c-0.3-0.3-0.3-0.9 0-1.2z"
    />
  </icon-svg-base>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import IconSvgBase from '@/components/icons/IconSvgBase.vue'

export default defineComponent({
  name: 'IconAngle',
  components: {
    IconSvgBase,
  },
})
</script>

<style lang="scss" module>
.path {
  width: 1em;
  height: 1em;
}
</style>
